import React from 'react'
import { FormattedMessage } from 'react-intl'
import manoMovilLogotipo from '../../assets/img/mano-movil-logotipo.png'

class Ventajas extends React.Component {
    render() {
        return (
            <div className="services container">
                <div className="image">
                    <img alt="mano_movil_logotipo" src={manoMovilLogotipo} />
                </div>
                <div className="text">
                    <ul>
                        <li>
                            <FormattedMessage id="consulta_delHistorial_de_actividad" defaultMessage="Consulta del historial de actividad" />.<br />
                            <FormattedMessage
                                id="en_todo_momento_se_podra_revisar_el_historico_de_las_acciones_realizadas_por_los_diferentes_usuarios_a_lo_largo_del_tiempo_esto_te_permitira_generar_estadisticas_sobre_los_habitos_de_las_personas_que_usen_tus_dependencias"
                                defaultMessage="En todo momento se podrá revisar el histórico de las acciones realizadas por los diferentes usuarios a lo largo del tiempo. Esto te permitirá generar estadísticas sobre los hábitos de las personas que usen tus dependencias"
                            />
                        </li>
                        <li>
                            <FormattedMessage id="funcionamiento_sin_conectividad_de_datos" defaultMessage="Funcionamiento sin conectividad de datos" />.<br />
                            <FormattedMessage
                                id="en_caso_de_falta_de_cobertura_de_datos_el_sistema_permita_la_apertura_mediante_llamada_perdida"
                                defaultMessage="En caso de falta de cobertura de datos el sistema permita la apertura mediante llamada perdida"
                            />
                        </li>
                        <li>
                            <FormattedMessage id="posibilidad_de_integracion_en_APP_propia_del_cliente" defaultMessage="Posibilidad de integración en APP propia del cliente" />.
                            <br />
                            <FormattedMessage
                                id="nos_integramos_en_tu_propia_app_empresarial_en_caso_de_que_lo_requieras_mediante_el_uso_de_API"
                                defaultMessage="Nos integramos en tu propia App empresarial en caso de que lo requieras mediante el uso de API"
                            />
                        </li>
                        <li>
                            <FormattedMessage id="modulo_de_control_de_presencia_adicional_disponible" defaultMessage="Módulo de control de presencia adicional disponible" />.
                            <br />
                            <FormattedMessage
                                id="el_sistema_dispone_de_un_modulo_de_control_de_presencia_mediante_codigo_qr_o_lector_nfc_que_permite_el_control_horario_de_fichajes_por_ejemplo"
                                defaultMessage="El sistema  dispone de un módulo de control de presencia mediante código QR o lector NFC que permite el control horario de fichajes, por ejemplo"
                            />
                        </li>
                        <li>
                            <FormattedMessage id="Instalacion_sencilla" defaultMessage="Instalación sencilla" />
                            <br />
                            <FormattedMessage
                                id="solamente_necesitamos_cambiar_el_bombin_cerrajero_o_uno_mismo"
                                defaultMessage="Solamente necesitamos cambiar el bombín (cerrajero o uno mismo)"
                            />
                        </li>
                        <li>
                            <FormattedMessage id="informacion_disponible" defaultMessage="Información disponible" />.<br />
                            <FormattedMessage
                                id="sabremos_exactamente_quien_cuando_y_durante_cuanto_tiempo_accede_a_tu_vivienda"
                                defaultMessage="Sabremos exactamente quien, cuando y durante cuanto tiempo accede a tu vivienda"
                            />
                        </li>
                        <li>
                            <FormattedMessage id="apertura_de_portero_disponible" defaultMessage="Apertura de portero disponible" />.<br />
                            <FormattedMessage
                                id="el_sistema_permite_la_apertura_del_portero_comunitario_sin_necesidad_de_acceder_a_las_zonas_comunes_todo_desde_dentro_de_la_vivienda_con_una_pequena_cajita_junto_al_telefonillo"
                                defaultMessage="El sistema permite la apertura del portero comunitario sin necesidad de acceder a las zonas comunes, todo desde dentro de la vivienda con una pequeña cajita junto al telefonillo"
                            />
                        </li>
                        <li>
                            <FormattedMessage id="conexion_remota" defaultMessage="Conexión remota" />.<br />
                            <FormattedMessage id="mediante_WIFI_o_cable_de_red" defaultMessage="mediante WIFI o cable de red" />.
                        </li>
                        <li>
                            <FormattedMessage id="version_bluetooth" defaultMessage="Versión bluetooth" />.<br />
                            <FormattedMessage
                                id="para_el_caso_en_que_no_exista_internet_en_la_vivienda_en_este_caso_se_usa_la_propia_conexion_de_datos_del_smartphone_para_realizar_la_conexion_a_la_plataforma"
                                defaultMessage="para el caso en que no exista internet en la vivienda. En este caso se usa la propia conexión de datos del Smartphone para realizar la conexión a la plataforma"
                            />
                        </li>
                        <li>
                            <FormattedMessage id="sistema_totalmente_seguro" defaultMessage="Sistema totalmente seguro" />.<br />
                            <FormattedMessage
                                id="toda_el_envio_de_informacion_y_claves_es_bajo_cifrado_de_seguridad"
                                defaultMessage="Toda el envío de información y claves es bajo cifrado de seguridad"
                            />
                        </li>
                        <li>
                            <FormattedMessage id="compatible" defaultMessage="Compatible" />.<br />
                            <FormattedMessage
                                id="con_la_mayoria_de_cerraduras_electronicas_el_sistema_usa_la_apertura_mediante_mando_a_distancia_de_cualquier_cerradura_electronica_tambien_puede_usar_cerraderos_electronicos_conectados_o_cerraduras_con_bluetooth"
                                defaultMessage=" con la mayoría de cerraduras electrónicas. El sistema usa la apertura mediante mando a distancia de cualquier cerradura electrónica, también puede usar cerraderos electrónicos conectados o cerraduras con bluetooth"
                            />
                        </li>
                        <li>
                            <FormattedMessage id="instalacion_no_invasiva" defaultMessage="Instalación no invasiva" />.<br />
                            <FormattedMessage
                                id="consta_simplemente_de_una_pequena_cajita_junto_al_telefonillo_del_tamano_de_una_caja_de_cerillas_grande"
                                defaultMessage="Consta simplemente de una pequeña cajita junto al telefonillo del tamaño de una caja de cerillas grande"
                            />
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}

export default Ventajas



// WEBPACK FOOTER //
// ./src/components/home/Services.js